import React, { FC } from 'react';
import { Button } from '@pisaka/ui';
import { Menu } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import logoImg from './logo.svg';

interface User {
  id: number;
  name?: string;
  email: string;
}

type PropsType = {
  toggleSidebar: () => void;
  user?: User;
  tokensRemaining?: number;
  onBuyTokens?: () => void;
};

const formatTokens = (n: number): string => {
  if (n < 10000) return n.toLocaleString();
  if (n < 1000000) return `${Math.floor(n / 1000)}k`;
  return `${(n / 1000000).toFixed(1).replace(/\.0$/, '')}M`;
};

const HeaderComponent: FC<PropsType> = ({ toggleSidebar, user, tokensRemaining, onBuyTokens }) => {
  const { t } = useTranslation();

  const isLoggedIn = user && +user.id;
  const noTokens = isLoggedIn && tokensRemaining === 0;

  return (
    <div className="sticky top-0 left-0 right-0 z-10 flex items-center justify-between bg-white border-b border-gray-200 shadow-sm h-[60px] px-2 lg:px-4">
      <div className="flex items-center gap-2">
        <button
          onClick={toggleSidebar}
          className="flex items-center justify-center cursor-pointer hover:opacity-70 transition-opacity"
          aria-label="Menu"
        >
          <Menu className="w-6 h-6" />
        </button>
        <a href="/"><img src={logoImg} alt="Писака" className="w-[35px] h-[35px]" /></a>
      </div>
      <div className="flex items-center gap-3">
        {isLoggedIn && (
          <div className="flex items-center gap-2">
            <div className="flex flex-col items-end leading-none">
              <span className={`text-sm font-semibold ${noTokens ? 'text-red-500' : 'text-foreground'}`}>
                {formatTokens(tokensRemaining ?? 0)}
              </span>
              <span className="text-[10px] text-muted-foreground">{t('profile.tokensPurchasedLabel')}</span>
            </div>
            <Button
              size="sm"
              className="h-8 text-sm whitespace-nowrap bg-gradient-accent hover:bg-accent shadow-accent"
              onClick={onBuyTokens}
            >
              {t('profile.buyTokens')}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default HeaderComponent;
